import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getExtensionGroupDetailsPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ExtensionGroupPrivileges } from '../models/extension-group-privileges';
import { ExtensionGroupOrderingOptions, ExtensionGroupRegisterOptions } from '../models/extension-register-options';
import { ExtensionGroupRegisterListItem } from '../models/extension-register-results.model';
import { ExtensionGroupsFilterOption } from '../models/extensions-group-filter-option';
import {
   createExtensionGroup,
   extensionGroupRegisterAdapterActions,
   extensionGroupRegisterInitialFilter,
} from '../state/extension-group-register.actions';
import * as extensionGroupRegisterReducer from '../state/extension-group-register.reducer';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-group-register',
    styleUrls: ['./extension-group-register.component.scss'],
    templateUrl: './extension-group-register.component.html',
    standalone: false
})
export class ExtensionGroupRegisterComponent
   extends Register<ExtensionGroupRegisterListItem, ExtensionGroupRegisterOptions, ExtensionGroupOrderingOptions>
   implements OnInit
{
   columns: string[] = ['name', 'description', 'created', 'extensions', 'extensionGroupActionsMenu'];

   entityName = 'Extension Group';

   accountId: number | null;
   extensionGroupPrivileges$: Observable<ExtensionGroupPrivileges>;

   filters: ExtensionGroupsFilterOption[];

   constructor(public store: Store, private twoColumnLayoutService: TwoColumnLayoutService) {
      super(store, extensionGroupRegisterReducer.selectors, extensionGroupRegisterAdapterActions);
      this.extensionGroupPrivileges$ = store.pipe(select(getExtensionGroupDetailsPrivileges));

      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: ExtensionGroupsFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
            // set selected ID to null when account changes
            this.twoColumnLayoutService.setSelectedId(null);
         });
   }

   ngOnInit() {
      this.store.dispatch(extensionGroupRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createExtensionGroup());
   }
}
